import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, initializeAuth, indexedDBLocalPersistence, Auth } from 'firebase/auth';
import { Capacitor } from '@capacitor/core';
import { getFirestore, Firestore } from 'firebase/firestore';
// import { getStorage, FirebaseStorage } from 'firebase/storage';
// import { getAnalytics, Analytics, isSupported as analyticsSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'appId'] as const;
const missing = requiredKeys.filter((k) => !firebaseConfig[k]);
if (missing.length > 0) {
  throw new Error(
    `[firebase] Missing required env vars: ${missing
      .map((k) => `REACT_APP_FIREBASE_${k.replace(/[A-Z]/g, (m) => '_' + m).toUpperCase()}`)
      .join(', ')}`
  );
}

export const app: FirebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
// Capacitor WKWebView에서 getAuth() 기본 persistence(localStorage)가 hang하므로
// initializeAuth + indexedDBLocalPersistence 사용
export const auth: Auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);
export const db: Firestore = getFirestore(app);

// export const storage: FirebaseStorage = getStorage(app);
// export const analytics: Promise<Analytics | null> = analyticsSupported().then((ok) =>
//   ok ? getAnalytics(app) : null
// );

export default app;
